import React, { useState } from "react";
import Slider from "react-slick";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import "./NewsSlider.css";
import ArrowRight from "./ArrowRight.svg";
import ArrowLeft from "./ArrowLeft.svg";
import news3 from "./assets/images/news3.webp";
import news5 from "./assets/images/news5.webp";
import news6 from "./assets/images/news6.webp";
import news8 from "./assets/images/news8.webp";
import news9 from "./assets/images/news9.webp";
import news10 from "./assets/images/news10.webp";
import news11 from "./assets/images/news11.webp";
import news13 from "./assets/images/news13.webp";
import news15 from "./assets/images/news15.webp";
import news16 from "./assets/images/news16.webp";
import news17 from "./assets/images/news17.webp";
import news18 from "./assets/images/news18.webp";
import news19 from "./assets/images/news19.webp";
import news20 from "./assets/images/news20.webp";
import news21 from "./assets/images/news21.webp";
import news22 from "./assets/images/news22.webp";
import news23 from "./assets/images/news23.webp";
import news24 from "./assets/images/news24.webp";
import news25 from "./assets/images/news25.webp";
import news26 from "./assets/images/news26.webp";
import news27 from "./assets/images/news27.webp";
import news28 from "./assets/images/news28.webp";
import news29 from "./assets/images/news29.webp";
import news30 from "./assets/images/news30.webp";
import news31 from "./assets/images/news31.webp";
import news32 from "./assets/images/news32.webp";
import news33 from "./assets/images/news33.webp";
import news34 from "./assets/images/news34.webp";
import news35 from "./assets/images/news35.webp";
import news36 from "./assets/images/news36.webp";
import news37 from "./assets/images/newArticle1.webp";
import news38 from "./assets/images/newsArticle2.webp";
import news39 from "./assets/images/newsArticle3.webp";
import news40 from "./assets/images/newsArticle4.webp";
import news41 from "./assets/images/newsArticle5.webp";
import news42 from "./assets/images/news42.webp";
import news43 from "./assets/images/news43.webp";
import news44 from "./assets/images/news44.webp";
import img001 from './assets/img001.jpeg'
import img002 from './assets/img002.jpeg'
import img003 from './assets/img003.jpeg'
import img004 from './assets/img004.jpeg'
import img005 from './assets/img005.jpeg'
import img006 from './assets/img006.jpeg'
import img007 from './assets/img007.jpeg'
import img008 from './assets/img008.jpeg'
import img009 from './assets/img009.jpeg'
import img010 from './assets/img010.jpeg'
import img011 from './assets/img011.jpeg'
import img012 from './assets/img012.jpeg'
import img013 from './assets/img013.jpeg'

const videos = [
  { image: img001 },
  { image: img002 },
  { image: img003 },
  { image: img004 },
  { image: img005 },
  { image: img006 },
  { image: img007 },
  { image: img008 },
  { image: img009 },
  { image: img010 },
  { image: img011 },
  { image: img012 },
  { image: img013 },
  { image: news42 },
  { image: news43 },
  { image: news44 },
  { image: news3 },
  { image: news5 },
  { image: news6 },
  { image: news8 },
  { image: news9 },
  { image: news10 },
  { image: news11 },
  { image: news13 },
  { image: news15 },
  { image: news16 },
  { image: news17 },
  { image: news18 },
  { image: news19 },
  { image: news20 },
  { image: news21 },
  { image: news22 },
  { image: news23 },
  { image: news24 },
  { image: news25 },
  { image: news26 },
  { image: news27 },
  { image: news28 },
  { image: news29 },
  { image: news30 },
  { image: news31 },
  { image: news32 },
  { image: news33 },
  { image: news34 },
  { image: news35 },
  { image: news36 },
  { image: news37 },
  { image: news38 },
  { image: news39 },
  { image: news40 },
  { image: news41 },
  
];

const NextArrow = (props) => {
  const { style, onClick } = props;
  return (
    <button
      className="btn newsBtn"
      style={{
        ...style,
        position: "absolute",
        top: "50%",
        right: "-4%",
        marginTop: "20px",
      }}
      onClick={onClick}
    >
      <img
        loading="lazy"
        src={ArrowRight}
        alt="Next"
        style={{ width: "25px" }}
      />
    </button>
  );
};

const PrevArrow = (props) => {
  const { style, onClick } = props;
  return (
    <button
      className="btn newsBtn"
      style={{
        ...style,
        position: "absolute",
        top: "50%",
        left: "-4%",
        marginTop: "20px",
        zIndex: "2",
      }}
      onClick={onClick}
    >
      <img
        loading="lazy"
        src={ArrowLeft}
        alt="Previous"
        style={{ width: "25px" }}
      />
    </button>
  );
};

const NewsSlider = () => {
  const [activeCard, setActiveCard] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [largeImage, setLargeImage] = useState("");

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const handleCardClick = (index) => {
    setLargeImage(videos[index].image);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setLargeImage("");
  };

  return (
    <div className="news-slider-container pb-4">
      <Slider {...settings}>
        {videos.map((video, index) => (
          <div key={index} className="news-slide">
            <div className="newsCard" onClick={() => handleCardClick(index)}>
              <img
                loading="lazy"
                src={video.image}
                alt="News Image"
                className="news-img"
              />
            </div>
          </div>
        ))}
      </Slider>
      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img
              loading="lazy"
              src={largeImage}
              alt="Large News"
              className="large-image"
            />
            <button className="close-button" onClick={closeModal}>
              <FontAwesomeIcon
                className="bg-[#fff] rounded-full hover:bg-[#000]  hover:text-[#fff] transition m-0"
                icon={faXmark}
                style={{
                  border: "4px solid #f0f0f0",
                  padding: "5px",
                }}
              />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default NewsSlider;
